import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageErrorComponent } from './shared/components/page-error/page-error.component';
import { Router, NavigationEnd } from '@angular/router';
import { EmpresaGuard } from './guards/empresa.guard';
import { ValidarEmpresasGuard } from './modulos/punto-venta/guards/validar-empresas.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modulos/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'main',
    loadChildren: () =>
      import('./modulos/main/main.module').then((m) => m.MainModule),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./modulos/home/home.module').then((m) => m.HomeModule),
  },
  {
    canActivate: [ValidarEmpresasGuard],
    path: 'punto-venta',
    loadChildren: () =>
      import('./modulos/punto-venta/punto-venta.module').then(
        (m) => m.PuntoVentaModule,
      ),
  },
  {
    path: 'mesa-ayuda',
    loadChildren: () =>
      import('./modulos/mesa-ayuda/mesa-ayuda.module').then(
        (m) => m.MesaAyudaModule,
      ),
  },
  {
    path: 'administracion-gastos',
    loadChildren: () =>
      import('./modulos/administracion-gastos/administracion-gastos.module').then(
        (m) => m.GastosModule,
      ),
  },
  {
    path: 'ecommerce',
    loadChildren: () =>
      import('./modulos/ecommerce/ecommerce.module').then(
        (m) => m.EcommerceModule,
      ),
  },
  {
    path: 'reportes',
    loadChildren: () =>
      import('./modulos/reporteador/reporteador.module').then(
        (m) => m.ReporteadorModule,
      ),
  },
  {
    canActivate: [EmpresaGuard],
    path: 'wms',
    loadChildren: () =>
      import('./modulos/wms/wms.module').then((m) => m.WmsModule),
  },
  {
    path: 'inventarios',
    loadChildren: () =>
      import('./modulos/inventarios/inventarios.module').then(
        (m) => m.InventariosModule,
      ),
  },
  {
    path: 'suministros',
    loadChildren: () =>
      import('./modulos/suministros/suministros.module').then(
        (m) => m.SuministrosModule,
      ),
  },
  {
    path: 'notfound',
    component: PageErrorComponent,
  },
  {
    path: 'recursos-humanos',
    loadChildren: () =>
      import('./modulos/recursos-humanos/recursos-humanos.module').then(
        (m) => m.RecursosHumanosModule,
      ),
  },
  {
    path: 'marketing',
    loadChildren: () =>
      import('./modulos/marketing/marketing.module').then(
        (m) => m.MarketingModule,
      ),
  },
  {
    path: 'it',
    loadChildren: () =>
      import('./modulos/gestion-it/gestion-it.module').then(
        (m) => m.GestionItModule,
      ),
  },
  {
    path: 'compras',
    loadChildren: () =>
      import('./modulos/compras/compras.module').then((m) => m.ComprasModule),
  },
  {
    path: 'canje',
    loadChildren: () =>
      import('./modulos/canje/canje.module').then((m) => m.CanjeModule),
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
